module.exports = __webpack_public_path__ + "media/rick.bb54483e.webm";